// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dd[data-v-6c28eff0]{height:48px;width:240px;box-shadow:none!important;border-radius:0}.dd[data-v-6c28eff0] .v-input__slot{box-shadow:none!important;border-radius:0!important}", ""]);
// Exports
module.exports = exports;
